import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TagEditorContextType {
  isTagEditorOpen: boolean;
  openTagEditor: () => void;
  closeTagEditor: () => void;
}

const TagEditorContext = createContext<TagEditorContextType | undefined>(undefined);

export function TagEditorProvider({ children }: { children: ReactNode }) {
  const [isTagEditorOpen, setIsTagEditorOpen] = useState(false);

  const openTagEditor = () => {
    setIsTagEditorOpen(true);
  };

  const closeTagEditor = () => {
    setIsTagEditorOpen(false);
  };

  return (
    <TagEditorContext.Provider
      value={{
        isTagEditorOpen,
        openTagEditor,
        closeTagEditor
      }}
    >
      {children}
    </TagEditorContext.Provider>
  );
}

export function useTagEditor() {
  const context = useContext(TagEditorContext);
  if (context === undefined) {
    throw new Error('useTagEditor must be used within a TagEditorProvider');
  }
  return context;
}